var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('b-container',[_c('b-card-body',[_c('h4',{staticClass:"card-title font-weight-bold",staticStyle:{"margin-bottom":"40px"}},[_vm._v("\n        Seite wurde nicht gefunden\n      ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }